import { Api } from '@/api/Api';
// Базовый URL
export var apiClient = new Api({
    baseUrl: 'https://cinemaguide.skillbox.cc',
    baseApiParams: {
        credentials: 'include'
    }
});
